import React, { PropsWithChildren } from 'react';
import { Box, PropsOf } from '@landr/maestro';
import { css } from '@landr/styled-system/css';

const borderGradientStyles = css({
    borderRadius: 'modal',
    overflow: 'hidden',
    padding: '1px',
    background:
        'linear-gradient(to bottom, {colors.border.primary/60} 0%, {colors.border.primary/30} 100%)',
    width: '100%',
});

const backgroundGradientStyles = css({
    borderRadius: 'modal',
    overflow: 'hidden',
    background: `{colors.surface.medium} radial-gradient(
        71.25% 100% at 50% 0%,
        {colors.surface.primary.high/10} 0%,
        {colors.surface.primary.high/0} 100%
    )`,
});

export const GradientBox: React.FC<
    PropsWithChildren<{ backgroundOverride?: string } & PropsOf<typeof Box>>
> = ({ children, backgroundOverride, ...rest }) => (
    <Box className={borderGradientStyles} {...rest}>
        <Box
            className={backgroundGradientStyles}
            background={backgroundOverride}
        >
            {children}
        </Box>
    </Box>
);
